module.exports = __webpack_public_path__ + "img/li.fb5437d3.svg";